var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.selectedPaymentType && _vm.pageLoaded
    ? _c(
        "div",
        { staticClass: "pricing-breakdown-container w-full" },
        [
          _c(
            "div",
            { staticClass: "pricing-breakdown-header flex justify-between" },
            [
              _c(
                "h5",
                { staticClass: "pricing-breakdown-title lowercase capitalize" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.renewalsPersistedVariables.jsonContent.text.products
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex pt-2.5" }, [
                _vm.isPhoenixCustomer
                  ? _c(
                      "button",
                      {
                        staticClass: "flex gap-1/4 justify-between w-30",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("adjustQuantities")
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.checkoutSharedContent.renewalEditIcon
                              .fields.file.url,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "edit-fields" }, [
                          _vm._v(
                            _vm._s(
                              _vm.renewalsPersistedVariables.jsonContent.buttons
                                .editQuantities
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.softwareCart.length > 0
            ? _c("v-table", {
                key: "table1",
                attrs: {
                  columns: _vm.buildHeaders("software"),
                  rows: _vm.buildRows("software"),
                  tableClass: "col xs-12 padding-top",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hardwareCart.length > 0
            ? _c("v-table", {
                key: "table2",
                attrs: {
                  columns: _vm.buildHeaders("hardware"),
                  rows: _vm.buildRows("hardware"),
                  tableClass: "col xs-12 padding-top-2",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("breakdown-table", {
            attrs: {
              rows: _vm.pricingBreakdown,
              tableClass:
                "col xs-12 sm-12 md-offset-4 md-8 lg-offset-6 lg-6 padding-top-2 no-side-padding",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }